import cookies from 'js-cookie'

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$cookies', { value: cookies })
  },
}
